module.exports = __webpack_public_path__ + "static/img/packaged-water_256.c470c6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packaged-water_256.png
// module id = NPjW
// module chunks = 0